// extracted by mini-css-extract-plugin
module.exports = {"post":"blogPost-module--post--2-Si9","postTitle":"blogPost-module--postTitle--2NHS2","postDate":"blogPost-module--postDate--22v6l","postImg":"blogPost-module--postImg--ntsTm"};